<script setup>

import { useFormFieldBuilder } from '@/composables/form/useFormBuilder';
import { useFormFieldTypes } from '@/composables/form/useFormFieldTypes';
import {computed, defineProps} from 'vue'


const model = defineModel()

const props = defineProps({
  formData: { type: Object, required: true },
  formErrors: { type: [Array, Object], default: () => [] },
  parentId: String,
  withId: {Boolean, default: true}
})

const { formFieldTypes } = useFormFieldTypes();

const component = computed(() => useFormFieldBuilder(props.formData))

const id = computed(() => {
  if(!props.withId){
    return component.value.data.name
  }else{
    return component.value.data.name+'_'+component.value.data.id
  }
})

const name = computed(() => {
  if(formFieldTypes.SELECT === component.value.data.type || formFieldTypes.SELECTMULTIPLE === component.value.data.type ){
    return component.value.data.name+'_'+component.value.data.id
  }

  return component.value.data.name
})

const options = computed(() => (formFieldTypes.SELECT === component.value.data.type) ? component.value.data.options_formatted : component.value.data.options)

const errors = computed(() => {
  return props?.formErrors[id.value] || {}
})


</script>

<template>
  <div class="mb-5">
    <component
      v-if="component"
      :is="component?.component"
      v-bind="{...component.data, parentId: props.parentId ? '#'+props.parentId : null, options: options, placeholderText: component.data.placeholder}"
      :name="name"
      v-model="model[id]"
      :errors="errors"
    />
  </div>
</template>

<style scoped>

</style>